<!-- Toolbar -->
<div class="tc-toolbar">
  <div class="tc-search">
    <i class="bx bx-search" aria-hidden="true"></i>
    <input
      type="text"
      placeholder="Search types..."
      aria-label="Search types"
      [(ngModel)]="searchQuery"
      (input)="filterTypes()"
    />
  </div>

  <div class="fnf-segmented fnf-segmented--compact" role="tablist">
    <button
      type="button"
      class="fnf-segment"
      [class.fnf-segment--active]="view === 'list'"
      (click)="changeView('list')"
    >
      <i class="bx bx-list-ul" aria-hidden="true"></i> List
    </button>
    <button
      type="button"
      class="fnf-segment"
      [class.fnf-segment--active]="view === 'grid'"
      (click)="changeView('grid')"
    >
      <i class="bx bx-grid-alt" aria-hidden="true"></i> Grid
    </button>
  </div>

  <button
    type="button"
    class="tc-add-btn"
    [ngClass]="{
      'tc-disabled': isPosManagedProvider,
    }"
    (click)="addNewType()"
  >
    <i class="bx bx-plus" aria-hidden="true"></i> Add New Type
  </button>
</div>

@if (displayLoading) {
  <div
    class="d-flex flex-column align-items-center justify-content-center common-loading-container"
  >
    <div class="w-25 text-center">
      <img class="common-loading" src="assets/menu_loading.gif" alt="common loading" />
      <p class="common-loading-text">Loading types, please wait...</p>
    </div>
  </div>
} @else if (visibleTypes.length) {
  <!-- ------------------------------------------------------------- list -->
  @if (view === 'list') {
    <section class="tc-card">
      <div class="tc-scroll">
        <table class="tc-table">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Categories</th>
              <th scope="col">Mandatory</th>
              <th scope="col">Selection Type</th>
              <th scope="col" class="tc-col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (type of visibleTypes; track type.id || type.name; let i = $index) {
              <tr class="tc-type-row" [class.tc-type-row--open]="activeAccordionIndex === i">
                <td>
                  <button
                    type="button"
                    class="tc-disclosure"
                    (click)="toggleAccordion(i)"
                    [attr.aria-expanded]="activeAccordionIndex === i"
                  >
                    <i
                      class="bx"
                      [ngClass]="
                        activeAccordionIndex === i ? 'bx-chevron-down' : 'bx-chevron-right'
                      "
                      aria-hidden="true"
                    ></i>
                    <span class="tc-type-name">{{ type.name }}</span>
                  </button>
                  @if (type.is_default) {
                    <span class="tc-default">Default</span>
                  }
                </td>
                <td class="tc-muted">{{ type.categories?.length || 0 }} Categories</td>
                <td>
                  <span
                    class="tc-pill"
                    [ngClass]="type.is_mandatory ? 'tc-pill--yes' : 'tc-pill--no'"
                  >
                    {{ type.is_mandatory ? 'Yes' : 'No' }}
                  </span>
                </td>
                <td>
                  <span class="tc-pill tc-pill--select">{{ selectionLabel(type) }}</span>
                </td>
                <td class="tc-col-actions">
                  <button
                    type="button"
                    class="tc-icon-btn"
                    matTooltip="Edit type"
                    (click)="addNewType(type)"
                  >
                    <i class="bx bx-edit-alt" aria-hidden="true"></i>
                  </button>
                  <button
                    type="button"
                    class="tc-icon-btn tc-icon-btn--danger"
                    matTooltip="Delete type"
                    [ngClass]="{
                      'tc-disabled': isPosManagedProvider,
                    }"
                    (click)="deleteType(type)"
                  >
                    <i class="bx bx-trash" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>

              @if (activeAccordionIndex === i) {
                <tr class="tc-sub-wrap">
                  <td colspan="5">
                    <div class="tc-sub">
                      <p class="tc-sub-head">Categories under {{ type.name }}</p>
                      @for (category of type.categories; track category.id || category.name) {
                        <div class="tc-sub-row">
                          <span>{{ category.name }}</span>
                          <span class="tc-sub-actions">
                            <button
                              type="button"
                              class="tc-icon-btn"
                              matTooltip="Edit category"
                              [ngClass]="{
                                'tc-disabled': isPosManagedProvider,
                              }"
                              (click)="addCategory(type)"
                            >
                              <i class="bx bx-edit-alt" aria-hidden="true"></i>
                            </button>
                            <button
                              type="button"
                              class="tc-icon-btn tc-icon-btn--danger"
                              matTooltip="Delete category"
                              [ngClass]="{
                                'tc-disabled': isPosManagedProvider,
                              }"
                              (click)="deleteCategory(type, category)"
                            >
                              <i class="bx bx-trash" aria-hidden="true"></i>
                            </button>
                          </span>
                        </div>
                      }
                      <button
                        type="button"
                        class="tc-add-category"
                        [ngClass]="{
                          'tc-disabled': isPosManagedProvider,
                        }"
                        (click)="addCategory(type)"
                      >
                        <i class="bx bx-plus" aria-hidden="true"></i> Add Category
                      </button>
                    </div>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </section>
  }

  <!-- ------------------------------------------------------------- grid -->
  @if (view === 'grid') {
    <div class="tc-grid">
      @for (type of visibleTypes; track type.id || type.name; let i = $index) {
        <article class="tc-grid-card">
          <header class="tc-grid-head">
            <h2 class="tc-grid-title">{{ type.name }}</h2>
            @if (type.is_default) {
              <span class="tc-default">Default</span>
            }
            <div class="btn-group custom-dropdown1 tc-grid-menu">
              <button
                type="button"
                class="tc-icon-btn"
                data-bs-toggle="dropdown"
                data-bs-display="static"
                aria-expanded="false"
                aria-label="Type actions"
              >
                <i class="bx bx-dots-horizontal-rounded" aria-hidden="true"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end">
                <li>
                  <a class="dropdown-item type-option" (click)="addNewType(type)">Edit Type</a>
                </li>
                <li>
                  <a class="dropdown-item type-option" (click)="addCategory(type)">Add Category</a>
                </li>
                <li>
                  <a
                    class="dropdown-item type-option delete-dropdown-item"
                    [ngClass]="{
                      'tc-disabled': isPosManagedProvider,
                    }"
                    (click)="deleteType(type)"
                  >
                    Delete Type
                  </a>
                </li>
              </ul>
            </div>
          </header>

          <div class="tc-badges">
            <span class="tc-pill" [ngClass]="type.is_mandatory ? 'tc-pill--yes' : 'tc-pill--no'">
              {{ type.is_mandatory ? 'Mandatory' : 'Optional' }}
            </span>
            <span class="tc-pill tc-pill--select">{{ selectionLabel(type) }}</span>
          </div>

          <p class="tc-count">{{ type.categories?.length || 0 }} Categories</p>

          <div class="tc-chips">
            @for (category of visibleCategories(type); track category.id || category.name) {
              <span class="tc-chip">{{ category.name }}</span>
            }
            @if (overflowCount(type) > 0) {
              <span class="tc-chip tc-chip--more">+{{ overflowCount(type) }} more</span>
            }
          </div>

          <footer class="tc-grid-foot">
            <button type="button" class="tc-manage" (click)="addCategory(type)">
              Manage Categories
              <i class="bx bx-right-arrow-alt" aria-hidden="true"></i>
            </button>
          </footer>
        </article>
      }
    </div>
  }
} @else if (typesAnsCategories.length) {
  <div class="d-flex flex-column align-items-center justify-content-center common-empty-container">
    <p class="common-empty-header">No matching types</p>
    <p class="common-empty-sub-text">Try a different search term.</p>
  </div>
} @else {
  <div class="d-flex flex-column align-items-center justify-content-center common-empty-container">
    <img src="assets/no-orders-yet.svg" alt="No types" class="common-empty-img mb-3" />
    <p class="common-empty-header">No Types</p>
    <p class="common-empty-sub-text">Create a type to start grouping your categories.</p>
  </div>
}
